<div role="alert" class="udex-grid udex-mx-auto">
  <dcp-generic-configurator-error
    [titleDisplay]="titleDisplay"
    imgPath="../../../../assets/images/configurator/checkout_service_error.png"
    headline="configurator.error.somethingWrong"
  ></dcp-generic-configurator-error>

  <ng-container *ngIf="error?.isEligibleForRetry; else contactUsMessage">
    <div class="row justify-content-center">
      <div class="col-sm-8 col-12">
        <p class="text-center body--s">
          <span>
            {{'configurator.error.tryAgain.message1' | cxTranslate}}
          </span>
          <dcp-contact-us-link
            class="d-inline text-nowrap"
            [errorMessage]="error?.description"
          ></dcp-contact-us-link>
          <span
            *ngIf="error?.errorCode"
            class="configurator-unavailable-error text-nowrap"
          >&nbsp;{{'configurator.error.code' | cxTranslate: {errorCode: error.errorCode} }}</span>
        </p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="udex-mt-20 d-flex justify-content-center">
        <udex-button
          class="udex-mb-84 udex-button udex-button--wide "
          (click)="tryAgain()"
          (keydown.enter)="tryAgain()"
          data-cy="tryAgainButtonInTryAgainScenario"
          size="Large"
          design="Primary">{{'configurator.error.tryAgain.buttonText' | cxTranslate}}
        </udex-button>
      </div>
    </div>
  </ng-container>

  <ng-template #contactUsMessage>
    <div class="row d-flex justify-content-center" [ngClass]="{'udex-mb-24 udex-mb-sm-32': titleDisplay}">
      <div class="col-sm-7 col-12">
        <p role="alert" class="text-center body--s">
          {{'configurator.error.contactUs.message' | cxTranslate}}
          <dcp-contact-us-link
            class="d-inline"
            [isEnd]="false"
            [errorMessage]="error?.description"
          ></dcp-contact-us-link>
          {{'configurator.error.contactUs.proceed' | cxTranslate}}
          <span
            *ngIf="error?.errorCode"
            class="configurator-unavailable-error text-nowrap"
          >&nbsp;{{'configurator.error.code' | cxTranslate: {errorCode: error.errorCode} }}</span>
        </p>
      </div>
    </div>
  </ng-template>
</div>
